import { Component, ChangeDetectionStrategy, Output, EventEmitter } from '@angular/core';
import { Observable } from 'rxjs';
import { NotificationData, UserNotificationsService, UserNotificationsStore } from '@frontend-site/main-header/domain';

@Component({
    selector: 'p-user-notifications',
    templateUrl: './user-notifications.component.html',
    styleUrls: ['./user-notifications.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserNotificationsComponent {
    notificationData$: Observable<NotificationData[]> = this.userNotificationsStore.notifications$;
    @Output() closeEvent = new EventEmitter();

    constructor(private userNotificationsService: UserNotificationsService, private userNotificationsStore: UserNotificationsStore) {}

    clearAll(notificationData: NotificationData): void {
        this.userNotificationsService.removeAllNotifications(notificationData).subscribe();
    }
}
